/**
 * track_pageview everytime location changes
 */
export const usePageview = (): void => {};
